var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5553 7.1875C21.3251 6.33215 20.6507 5.65793 19.7955 5.4276C18.233 5 11.9831 5 11.9831 5C11.9831 5 5.73337 5 4.1709 5.4113C3.33215 5.64147 2.64132 6.3323 2.41115 7.1875C2 8.74983 2 11.9899 2 11.9899C2 11.9899 2 15.2464 2.41115 16.7924C2.64147 17.6476 3.3157 18.322 4.17105 18.5523C5.74983 18.9799 11.9833 18.9799 11.9833 18.9799C11.9833 18.9799 18.233 18.9799 19.7955 18.5686C20.6509 18.3384 21.3251 17.664 21.5554 16.8088C21.9666 15.2464 21.9666 12.0064 21.9666 12.0064C21.9666 12.0064 21.983 8.74983 21.5553 7.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 14.9867L15.1893 11.9933L9.99219 9L9.99219 14.9867Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a69eb9ca993d050601f3d8df0db620ef.svg";
export { ForwardRef as ReactComponent };